import React from 'react';
import { Box, TextField, MenuItem, Select, FormControl, TextareaAutosize } from '@mui/material';
import { FieldMappingItem } from '../../models';

interface OverlayFormFieldProps {
  field: FieldMappingItem;
  value: string;
  onChange: (fieldId: string, value: string) => void;
  containerWidth: number;
  containerHeight: number;
  disabled?: boolean;
}

export const OverlayFormField: React.FC<OverlayFormFieldProps> = ({
  field,
  value,
  onChange,
  containerWidth,
  containerHeight,
  disabled = false,
}) => {
  if (!field.position) return null;

  const { top, left, width, height } = field.position;

  // 위치와 크기를 퍼센트에서 픽셀로 변환
  const style: React.CSSProperties = {
    position: 'absolute',
    top: `${top}%`,
    left: `${left}%`,
    width: `${width}%`,
    height: `${height}%`,
    zIndex: 10,
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    fontSize: '12px',
    padding: '4px 8px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    boxSizing: 'border-box',
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    onChange(field.field_id, e.target.value);
  };

  const renderInput = () => {
    switch (field.type) {
      case 'textarea':
        return (
          <textarea
            value={value || ''}
            onChange={handleChange}
            placeholder={field.placeholder}
            disabled={disabled}
            style={{
              ...inputStyle,
              resize: 'none',
              fontFamily: 'inherit',
            }}
          />
        );

      case 'select':
        return (
          <select
            value={value || ''}
            onChange={handleChange}
            disabled={disabled}
            style={inputStyle}
          >
            <option value="">{field.placeholder || '선택하세요'}</option>
            {field.options?.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        );

      case 'date':
        return (
          <input
            type="date"
            value={value || ''}
            onChange={handleChange}
            disabled={disabled}
            style={inputStyle}
          />
        );

      case 'number':
        return (
          <input
            type="number"
            value={value || ''}
            onChange={handleChange}
            placeholder={field.placeholder}
            disabled={disabled}
            style={inputStyle}
          />
        );

      case 'text':
      default:
        return (
          <input
            type="text"
            value={value || ''}
            onChange={handleChange}
            placeholder={field.placeholder}
            maxLength={field.max_length}
            disabled={disabled}
            style={inputStyle}
          />
        );
    }
  };

  return <Box sx={style}>{renderInput()}</Box>;
};

export default OverlayFormField;
